import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Divider
} from "@mui/material";

const API = "https://api.haymestasarim.com/api";

export default function ReferansChangePasswordPage() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const submit = async () => {
    if (!oldPassword || !newPassword || !newPassword2) {
      return setMessage({
        type: "error",
        text: "Tüm alanlar zorunludur."
      });
    }

    if (newPassword !== newPassword2) {
      return setMessage({
        type: "error",
        text: "Yeni şifreler birbiriyle uyuşmuyor."
      });
    }

    if (newPassword.length < 8) {
      return setMessage({
        type: "error",
        text: "Yeni şifre en az 8 karakter olmalıdır."
      });
    }

    setLoading(true);
    setMessage(null);

    try {
      const token = localStorage.getItem("user_token");

      const res = await fetch(`${API}/profile/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          oldPassword,
          newPassword,
          newPassword2
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Şifre değiştirilemedi");
      }

      setMessage({
        type: "success",
        text: "Şifreniz başarıyla güncellendi."
      });

      setOldPassword("");
      setNewPassword("");
      setNewPassword2("");

    } catch (err) {
      setMessage({
        type: "error",
        text: err.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Card sx={{ width: 420, borderRadius: 2, boxShadow: 4 }}>
        <CardContent>
          <Typography variant="h6" align="center" fontWeight={600}>
            Şifre Değiştir
          </Typography>

          <Divider sx={{ my: 2 }} />

          {message && (
            <Typography
              sx={{
                mb: 2,
                fontSize: 14,
                color: message.type === "success" ? "green" : "red"
              }}
            >
              {message.text}
            </Typography>
          )}

          <TextField
            label="Mevcut Şifre"
            type="password"
            fullWidth
            margin="normal"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />

          <TextField
            label="Yeni Şifre"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <TextField
            label="Yeni Şifre (Tekrar)"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword2}
            onChange={(e) => setNewPassword2(e.target.value)}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={loading}
            onClick={submit}
          >
            {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
